import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { getBEMClasses } from '../helpers/cssClassesHelper';

import withAuthentication from '@t7x000/apex-web/lib/hocs/withAuthentication.js';
import {
  BuySellContainer,
  BuySellMakeTransactionContainer,
  BuySellBalancesContainer,
  BuySellOrderOverviewContainer,
} from '@t7x000/apex-web/lib/components/Retail/RetailBuySell';
import {
  accountsSelector,
  selectedAccountIdSelector,
} from '@t7x000/apex-web/lib/redux/margin/selectors/marginSelectors';
import { selectAccount } from '@t7x000/apex-web/lib/redux/actions/userActions';
import '@t7x000/apex-web/lib/layouts/Responsive/EotcBuySellLayout/EotcBuySellDesktopLayout.css';

import PageFooterLayout from '../layouts/PageFooterLayout/PageFooterLayout';

import './BuySellPage.css';

const classes = getBEMClasses('eotc-buy-sell-layout');

const BuySellPage = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const accounts = useSelector(accountsSelector);
  const selectedAccountId = useSelector(selectedAccountIdSelector);

  useEffect(() => {
    const selectedAccount = accounts.find((account) => account.AccountId === selectedAccountId);
    const isSelectedAccountSpot = selectedAccount && selectedAccount.AccountType === 'Asset';

    if (!isSelectedAccountSpot) {
      const spotAccount = accounts.find((account) => account.AccountType === 'Asset');
      if (spotAccount) {
        dispatch(selectAccount(spotAccount.AccountId, spotAccount.OMSID));
      }
    }
  }, [accounts, selectedAccountId, dispatch]);

  return (
    <React.Fragment>
      <div className={classes('accent-bar')} />
      <div className={classes('container')}>
        <div className={classes('col', ['lg'])}>
          <div className={classes('make-transaction-container container-with-shadow')}>
            <div className={classes('make-transaction-col-1 ')}>
              <BuySellMakeTransactionContainer>
                <BuySellContainer />
              </BuySellMakeTransactionContainer>
            </div>

            <div className={classes('make-transaction-col-2')}>
              <div className={classes('order-overview-container')}>
                <BuySellOrderOverviewContainer displayPricePerUnit />
              </div>

              <hr className={classes('right-panel-divider')} />

              <div className={classes('balances-container ')}>
                <div className={classes('balances-title')}>{t('Balances')}</div>
                <BuySellBalancesContainer />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className={classes('footer')}>
        <PageFooterLayout />
      </div>
    </React.Fragment>
  );
};

export default withAuthentication(BuySellPage);
